<div class="container">
  <div class="page">

    <div class="page-header">
      <h1 class="page-title">{{'Not found' | translate}}</h1>
    </div>

    <div class="page-body">

      <div class="content-wrapper text-center pt-5 pb-5">

        <fa-icon [icon]="faSadTear" [size]="'10x'"></fa-icon>

        <h3 class="mt-3">{{'The page that you requested, does not exist' | translate}}</h3>

      </div>

    </div>

  </div>

</div>

